export default "__VITE_ASSET__ff012d7c__"